import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay } from '@fortawesome/free-solid-svg-icons';
import Modal from './Modals/Modal';
import VideoList from './Modals/VideoModal/VideoList';
import './TextAndImagesList.css';

function VideoContentList({ curriculum, setCurriculum, clCardItem, setClCardItem, lessonParent, isUploadingViaApi, setIsUploadingViaApi }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="TILST" onClick={() => setIsOpen(true)}>
        <div className="TILST_A1">
          <FontAwesomeIcon icon={faCirclePlay} />
        </div>
        <div className="TILST_A2">
          Video List
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <VideoList curriculum={curriculum} setCurriculum={setCurriculum} clCardItem={clCardItem} setClCardItem={setClCardItem} lessonParent={lessonParent} isUploadingViaApi={isUploadingViaApi} setIsUploadingViaApi={setIsUploadingViaApi} />
      </Modal>
    </div>
  );
}

export default VideoContentList;
